import { api } from "../utils/AuthManager";

const DeleteClientPackage = async (id) => {
  return api
    .delete(`/api/client_package/${id}/`)

    .then((res) => {
      return res;
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export default DeleteClientPackage;
